import { render, staticRenderFns } from "./comment-form-page.vue?vue&type=template&id=526ada2a&"
import script from "./comment-form-page.vue?vue&type=script&lang=js&"
export * from "./comment-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports